export const pathHelper = (path: string) => {
    let string = path.split('/')
    string.splice(0, 1)
    let result = '/'
    if(string[0]) result = `/${string[0]}`
    if(string[1]) result += `/${string[1]}`
    return result
}